/**
 * (Sep 25, a follow-up to "the phlock camera fine ticket no longer shows the picture") the character's mail: the letters the city
 * sent — fines, deliveries, a finished build, the Media page's picture letters — kept with the character (PlayerState.mail, saved
 * with the player) instead of in one browser's memory, so Mail survives a reload and follows the character to another device.
 * The newest MAIL_MAX; a fine's evidence picture lives beside it (the browser that was flashed keeps it, and online it uploads it
 * to the server — `pic` — so another device can show it too).
 */
export interface MailLetter {
  id: string; title: string; text: string;
  /** when it came (ms since the epoch) */
  at: number;
  read?: boolean;
  /** (C) a content/media id: the picture the letter carries (docs/DESIGN_MEDIA.md) */
  media?: string;
  /** online: the server holds the fine's evidence picture (GET /evidence/<id>.jpg) */
  pic?: 1;
}
export const MAIL_MAX = 50;
/** a letter into the list, newest first; the same id again replaces the old copy. Returns the letters that fell off the end. */
export function keepLetter(list: MailLetter[], l: MailLetter, max = MAIL_MAX): MailLetter[] {
  const i = list.findIndex((x) => x.id === l.id); if (i >= 0) list.splice(i, 1);
  list.unshift(l);
  return list.length > max ? list.splice(max) : [];
}
/** a saved list, checked field by field (a save is data from disk or a browser) */
export function readMail(raw: unknown, max = MAIL_MAX): MailLetter[] {
  if (!Array.isArray(raw)) return [];
  const out: MailLetter[] = [];
  for (const r of raw as Record<string, unknown>[]) {
    if (!r || typeof r.id !== 'string' || typeof r.title !== 'string' || typeof r.text !== 'string') continue;
    out.push({ id: r.id.slice(0, 64), title: r.title.slice(0, 200), text: r.text.slice(0, 2000), at: typeof r.at === 'number' ? r.at : 0, ...(r.read ? { read: true } : {}), ...(typeof r.media === 'string' ? { media: r.media } : {}), ...(r.pic ? { pic: 1 as const } : {}) });
    if (out.length >= max) break;
  }
  return out;
}
/** an evidence id as it may name a file: the fine id's own characters (cameras.ts: base-36 time, a dash, base-36 person) */
export const EVIDENCE_ID = /^[a-z0-9]{1,12}-[a-z0-9]{1,12}$/;
